import React, { useEffect, useState, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.heat";
import axios from "axios";
import reportServices from "../../services/report-services";
import { URL_BASE } from "../../config/url-server";
import { es } from "date-fns/locale/es";
import { useForm } from "react-hook-form";
import { registerLocale } from "react-datepicker";
import farmService from "../../services/farm-service";
import lotService from "../../services/lot-service";
import DatePicker from "react-datepicker";
import { Divider, message, Spin } from "antd";
import moment from "moment";
import config from "../../config/config";
import { ToastContainer, toast } from 'react-toastify';
import sectionService from "../../services/section-service";
import mapServices from "../../services/map-services";

const Heatmap = () => {



    const [showTable, setShowTable] = useState(false);
    const [palms, setPalms] = useState(1);
    const [productivePalms, setProductivePalms] = useState(0);
    const [unproductivePalms, setUnproductivePalms] = useState(0);


    const [loading, setLoading] = useState(false);
    registerLocale("es", es);

    const start_date = moment().subtract(1, 'month').startOf('month').toDate();
    const end_date = moment().subtract(1, 'month').endOf('month').toDate();
    const [startDate, setStartDate] = useState(start_date);
    const [endDate, setEndDate] = useState(end_date);


    const [centerMap, setCenterMap] = useState([5.391078, -73.869958]); // Coordenadas predeterminadas
    const [zoom, setZoom] = useState(6);  // Zoom predeterminado
    const [heatData, setHeatData] = useState([]);
    const [markerData, setMarkerData] = useState([]);

    const mapRef = useRef(null); // Referencia al contenedor del mapa

    registerLocale("es", es);


    const [lotPalms, setLotPalms] = useState([]); // Puntos de todas las palmas del lote    
    const escoja = [{ _id: 0, name: "-ESCOJA-" }];
    const [listFarms, setListFarms] = useState(escoja);
    const [listLots, setListLots] = useState(escoja);
    const [farmId, setFarmId] = useState("0");
    const [lotId, setLotId] = useState("0");
    const [listSection, setListSection] = useState(escoja);





    const {
        register,
        getValues,
        setValue,
        formState: { errors },
    } = useForm();


    const clientId = localStorage.getItem("client");
    const accessToken = localStorage.getItem("token")

    const getLisFarm = async () => {
            if (farmId == "0") {
                let listado = await farmService.getList();
                if (listado) {
                    listado.push({ _id: 0, name: "-ESCOJA-" });
                    const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                    setListFarms(sortedItems);
                    //setValue("farm",0)
                }
            }
        };
    
    
    
    
        const getListSection = async (e) => {
            const code = e.target.value;
            if (code == "0") {
                setListSection(escoja);
                setListLots(escoja);
                setValue("section", "0")
                setValue("lot", "0")
                setValue("user", "0")
                return;
            }
            let listado = await sectionService.getListByFarm(code);
            listado.push({ _id: 0, name: "-ESCOJA-" });
            if (listado) {
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListSection(sortedItems);
                setValue("section", "0")
                setValue("lot", "0")
                setValue("user", "0")
            }
        };
    
    
    
        const getLisLots = async (e) => {
            const code = e.target.value;
            if (code == "0") {
                setListLots(escoja);
                setValue("lot", "0")
                setValue("user", "0")
                return;
            }
            let listado = await lotService.getListBySection(code);
            listado.push({ _id: 0, name: "-ESCOJA-" });
            if (listado) {
                const sortedItems = listado.sort((a, b) => a.name.localeCompare(b.name));
                setListLots(sortedItems);
                setValue("lot", "0")
                setValue("user", "0")
            }
        };
    



    const generateExcel = async () => {

        const farmId = getValues("farm");
        const lotId = getValues("lot");
        if (lotId == "0") {
            toast.error("Seleccione un lote", { autoClose: 1600 })
            return;
        }
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        setLoading(true);
        try {
            const sectionId = "0"
            const userId = "0"
            const response = await reportServices.generateHeatMapExcel(start, end, farmId, sectionId, lotId, userId);

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }


            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Palmas sin aplicaciones ${start} - ${end}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();

        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }



    const getUnproductivePalms = async () => {
        setShowTable(false)
        const farmId = getValues("farm");
        const lotId = getValues("lot");
        if (lotId == "0") {
            toast.error("Seleccione un lote", { autoClose: 1600 })
            return;
        }
        let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
        let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
        setLoading(true);
        try {
            const sectionId = "0"
            const userId = "0"
            const response = await mapServices.unproductivePalms(start, end, farmId, sectionId, lotId, userId);

            if (response?.error) {
                toast.error("No hay registros", { autoClose: 1600 })
                setLoading(false);
                return;
            }

            console.log("response", response.data)

            if (response.data.length == 0) {
                toast.error("No hay registros", { autoClose: 1600 })
                setShowTable(false); return;
            }

            setShowTable(true);

            const counter = parseInt(response.data[0].totalPalms) - parseInt(response.data[0].productivePalms);
            setPalms(response.data[0].totalPalms);
            setProductivePalms(response.data[0].productivePalms);
            setUnproductivePalms(counter);



        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    }




    const searchPalms = async () => {
        try {
            const farmId = getValues("farm");
            const lotId = getValues("lot");
            const user = "0"

            if (lotId == "0") {
                toast.error("Seleccione un lote", { autoClose: 1600 })
                return;
            }


            getUnproductivePalms()


            let start = moment(startDate).startOf("day").format('YYYY-MM-DD');
            let end = moment(endDate).endOf("day").format('YYYY-MM-DD');
            const params = { farmId, lotId, startDate: start, endDate: end, userId: user };
            const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };

            setLoading(true);
            const response = await axios.get(URL_BASE + "map/heat-map", config);
            const palms = response.data.data;

            const heatFormattedData = palms.map(palm => [
                palm.location.coordinates[1], // Latitud
                palm.location.coordinates[0], // Longitud
                palm.count // Intensidad (cantidad de registros)
            ]);

            if (palms.length > 0) {
                const lat = palms[0].location.coordinates[1];
                const long = palms[0].location.coordinates[0];
                setCenterMap([lat, long]);
                setZoom(18);  // Puedes ajustar el zoom aquí si quieres más detalle al mostrar los puntos
            }

            setHeatData(heatFormattedData);
            setMarkerData(palms);
            setLoading(false);
        } catch (error) {
            console.error("Error obteniendo las palmas:", error);
        }
    };

    useEffect(() => {
        getLisFarm();
    }, []);

    useEffect(() => {
        // Asegurarnos de que el contenedor del mapa esté disponible
        if (!mapRef.current) return;

        const map = L.map(mapRef.current, {
            center: centerMap,
            zoom: zoom,
        });

        // Aseguramos que se renderice el mapa aunque no haya datos
        L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
            attribution: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoIQ, and the GIS User Community"
        }).addTo(map);

        // Si hay datos de calor, se agrega la capa de calor
        if (heatData.length > 0) {
            L.heatLayer(heatData, {
                radius: 20,
                blur: 15,
                maxZoom: 17,
            }).addTo(map);
        }

        // Si hay datos de marcadores, se agrega cada uno
        if (markerData.length > 0) {
            markerData.forEach(palm => {
                const { location, lotName, lineName, palmName } = palm;

                const myIcon = L.icon({
                    iconUrl: "data:image/svg+xml,%3Csvg%20xmlns%3D'http://www.w3.org/2000/svg'%20width%3D'10'%20height%3D'10'%20viewBox%3D'0%200%2010%2010'%3E%3Ccircle%20cx%3D'5'%20cy%3D'5'%20r%3D'5'%20fill%3D'green'%20/%3E%3C/svg%3E",
                    iconSize: [10, 10],
                    iconAnchor: [5, 5],
                });

                if (location.coordinates[1] !== "0") {
                    const marker = L.marker([location.coordinates[1], location.coordinates[0]], { icon: myIcon }).addTo(map);
                    marker.bindPopup(`
                        <div>
                            <strong>Línea:</strong> ${lineName}<br />
                            <strong>Palma:</strong> ${palmName}<br />
                            <strong>Lote:</strong> ${lotName}<br />
                        </div>
                    `);
                }
            });
        }

        return () => {
            map.remove(); // Limpiar el mapa al desmontar el componente
        };
    }, [heatData, markerData, centerMap, zoom]);

    return (
        <div className="row">

            <ToastContainer />
            <div className="col-12 col-sm-2">
                <div className="col-12 ml-4 ms-2" style={{ marginTop: "-10px" }}>
                    <Divider orientation="left" style={{ border: "#AAAAAA" }}>Plantas sin aplicación</Divider>
                </div>

                <form className="form-react">
                    <div className="row ms-2">




                         <div className=" col-12">
                            <label className="text-secondary fw-bold">Finca</label>
                            <select
                                className="form-control text-secondary"

                                {...register("farm")}
                                onChange={(e) => getListSection(e)}
                            >
                                {listFarms.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="  col-12 col-sm-12">
                            <label className="text-secondary fw-bold">Sección</label>
                            <select
                                className="form-control text-secondary"
                                {...register("section")}
                                {...register("section")}
                                onChange={(e) => getLisLots(e)}
                            >
                                {listSection.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Lote</label>
                            <select
                                className="form-control text-secondary"
                                {...register("lot")}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setLotId(value);
                                }}
                            >
                                {listLots.map((option) => (
                                    <option key={option._id} value={option._id}>
                                        {option.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Desde</label>
                            <br />
                            <DatePicker
                                {...register("startDate")}
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                className="form-control text-secondary"
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                            />
                        </div>

                        <div className=" col-12">
                            <label className="text-secondary fw-bold">Hasta</label>
                            <br />
                            <DatePicker
                                {...register("endDate")}
                                locale="es"
                                dateFormat="yyyy-MM-dd"
                                className="form-control 
                                      text-secondary"
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                            />
                        </div>


                        <div className=" col-12">
                            <label className="text-secondary fw-bold">&nbsp;</label>
                            <br />
                            <Spin spinning={loading}>
                                <button
                                    className="btn btn-primary w-100"
                                    type="button"
                                    onClick={() => searchPalms()}
                                >
                                    <i className="bi bi-search fa-lg m-2" /> Buscar
                                </button>
                            </Spin>
                        </div>


                        <div className=" col-12 mb-4">
                            <label className="text-secondary fw-bold">&nbsp;</label>
                            <br />
                            <Spin spinning={loading}>
                                <button
                                    className="btn btn-info w-100"
                                    type="button"
                                    onClick={() => generateExcel()}
                                >
                                    <i className="bi bi-file-earmark-text fa-lg m-2" /> Exportar
                                </button>
                            </Spin>
                        </div>




                    </div>
                </form>


                <div className={showTable ? "col-12 ms-2 p-2" : "d-none"}>
                    <table className="table table-bordered table-striped table-hover table-sm text-center">
                        <thead className="table-primary">
                            <tr>
                                <th>Plantas:</th>
                                <th>Cantidad:</th>
                            </tr>
                        </thead>
                        <tbody>

                            <tr>
                                <td>Productivas</td>
                                <td>{productivePalms}</td>
                            </tr>

                            <tr>
                                <td>Improductivas</td>
                                <td>{unproductivePalms}</td>
                            </tr>

                             <tr>
                                <td>Productivas %</td>
                                <td>{((productivePalms/palms)*100).toFixed(1)}%</td>
                            </tr>

                            <tr>
                                <td>Improductivas %</td>
                                <td>{((unproductivePalms/palms)*100).toFixed(1)}%</td>
                            </tr>


                            <tr>
                                <td>Total palmas</td>
                                <td>{palms}</td>
                            </tr>

                        </tbody>


                    </table>


                   
                </div>

            </div>

            <div className="col-12 col-sm-10">
                <div ref={mapRef} style={{ height: "100vh", width: "100%" }} />
            </div>
        </div>
    );
};

export default Heatmap;
